/**
 * HeldBackNote (Phase 65 / BLU-594). The quiet amber "this is held back / not
 * shown" note shape shared by the unrecognised-option note, the duplicate-SKU
 * note (tier 1) and the truncated-variants banner (tier 3). This is the OBSERVE
 * shape — a passive explanation. The ACTIONABLE amber block (with a "Map it"
 * button) is deliberately NOT this component: fixable gaps get an affordance,
 * held-back facts get a note.
 */
import type { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface HeldBackNoteProps {
  children: ReactNode;
  className?: string;
}

export function HeldBackNote({ children, className }: HeldBackNoteProps) {
  return (
    <div className={cn('flex items-start gap-1.5 rounded-md border border-amber-300 bg-amber-50 px-2.5 py-2 text-xs text-amber-900', className)}>
      <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-700" aria-hidden="true" />
      <span className="min-w-0">{children}</span>
    </div>
  );
}
